(function () {
  let outOfStockProducts = [];

  function insertAdCards(productGrid) {
    const adDataEl = document.getElementById("collection-ad-data");

    if (!adDataEl) return;

    const adData = JSON.parse(adDataEl.textContent);

    if (!adData.interval || adData.interval < 1) return;

    // Remove previously inserted ads
    productGrid
      .querySelectorAll(".collection-ad-card")
      .forEach((el) => el.remove());

    const products = productGrid.querySelectorAll(
      '.grid__item[data-product-available="true"]'
    );

    products.forEach((product, index) => {
      if ((index + 1) % adData.interval !== 0) return;

      const ad = document.createElement("li");

      ad.className = "grid__item collection-ad-card";

      let mediaHtml = '';
      if (adData.isVideo) {
        mediaHtml = `
          <video
            src="${adData.url || adData.image}"
            class="collection-ad-card__image"
            autoplay
            muted
            loop
            playsinline
          ></video>
        `;
      } else {
        mediaHtml = `
          <img
            src="${adData.url || adData.image}"
            class="collection-ad-card__image"
            loading="lazy"
            alt="Collection Advertisement"
          >
        `;
      }

      ad.innerHTML = `
        <div class="card-wrapper product-card-wrapper">
          <div class="card card--standard">
            <a href="${adData.link || '#'}" class="collection-ad-card__link">
              ${mediaHtml}
            </a>
          </div>
        </div>
      `;

      product.insertAdjacentElement("afterend", ad);
    });
  }

  function collectOutOfStockProducts(productGrid) {
    const soldOutProducts = productGrid.querySelectorAll(
      '.grid__item[data-product-available="false"]'
    );

    soldOutProducts.forEach((item) => {
      outOfStockProducts.push(item.cloneNode(true));
      item.remove();
    });
  }

  function renderStoredOutOfStockProducts(productGrid) {
    if (!outOfStockProducts.length) return;

    const fragment = document.createDocumentFragment();

    outOfStockProducts.forEach((product) => {
      fragment.appendChild(product);
    });

    productGrid.appendChild(fragment);

    insertAdCards(productGrid);
  }

  const initInfiniteScroll = () => {
    const productGrid = document.getElementById("product-grid");
    const loader = document.querySelector(".js-infinite-scroll-loader");

    let isFetching = false;

    if (!productGrid) return;

    collectOutOfStockProducts(productGrid);

    // Initial ad render
    insertAdCards(productGrid);

    if (!loader) {
      renderStoredOutOfStockProducts(productGrid);
      return;
    }

    if (loader.dataset.initialized === "true") return;
    loader.dataset.initialized = "true";

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || isFetching) return;

          const nextUrl = loader.getAttribute("data-next-url");

          if (nextUrl) {
            fetchNextPage(nextUrl);
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px 1000px 0px",
        threshold: 0,
      }
    );

    observer.observe(loader);

    async function fetchNextPage(url) {
      if (isFetching) return;

      isFetching = true;
      loader.classList.add("is-loading");

      try {
        const response = await fetch(url);
        const text = await response.text();

        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, "text/html");

        const newProducts = htmlDocument.querySelectorAll(
          "#product-grid .grid__item"
        );

        const nextUrlElement =
          htmlDocument.querySelector(".js-infinite-scroll-loader");

        const nextUrl = nextUrlElement
          ? nextUrlElement.getAttribute("data-next-url")
          : null;

        const fragment = document.createDocumentFragment();

        newProducts.forEach((item) => {
          const available =
            item.dataset.productAvailable === "true";

          if (available) {
            fragment.appendChild(item);
          } else {
            outOfStockProducts.push(item.cloneNode(true));
          }
        });

        productGrid.appendChild(fragment);

        // Recalculate ads after new products are added
        insertAdCards(productGrid);

        if (nextUrl) {
          loader.setAttribute("data-next-url", nextUrl);
        } else {
          observer.disconnect();
          loader.remove();

          renderStoredOutOfStockProducts(productGrid);
        }
      } catch (error) {
        console.error("Infinite scroll fetch error:", error);
      } finally {
        isFetching = false;
        loader.classList.remove("is-loading");
      }
    }
  };

  initInfiniteScroll();

  document.addEventListener("shopify:section:load", () => {
    outOfStockProducts = [];
    initInfiniteScroll();
  });

  document.addEventListener("facet:updated", () => {
    outOfStockProducts = [];
    initInfiniteScroll();
  });
})();